import { connect } from "react-redux";
import { KAlert } from "./KAlert";
function mapStateToProps({ alert }) {
    return {
        msg: alert.msg,
        type: alert.type,
        hidden: alert.hidden,
    };
}
export default connect(mapStateToProps)(KAlert);
